import { useMutation } from "@apollo/client";

import {
  UpdateCustomerInput,
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables,
} from "../../API";
import { UPDATE_CUSTOMER } from "../../common/operations/mutations";

export const useUpdateCustomer = () => {
  const [updateCustomerMutation, { data, loading }] = useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UPDATE_CUSTOMER);

  const updateCustomer = async (input: UpdateCustomerInput) => {
    return await updateCustomerMutation({
      variables: {
        input,
      },
      fetchPolicy: "no-cache",
    });
  };

  return { updateCustomer, data, loading };
};
